import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-requests-group-qr-code',
  templateUrl: './job-requests-group-qr-code.component.html',
  styleUrls: ['./job-requests-group-qr-code.component.scss']
})
export class JobRequestsGroupQrCodeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
